"use client";

import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
      </div>;
  }
  return <>
      <nav className="hidden md:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList className="gap-1">
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-spring)] hover:text-primary hover:after:w-full hover:!bg-transparent focus:!bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
      </nav>

      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-t shadow-medium md:hidden z-50">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block px-4 py-3 text-sm font-medium text-foreground rounded-md hover:bg-accent hover:text-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Encabezado() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background border-b transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-[60px] shadow-medium" : "h-[80px] shadow-soft"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/" className="flex items-center hover:opacity-80 transition-opacity duration-[var(--duration-medium)]">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/guillermo_bogao_coaching_logo.png" alt="Guillermo Bogao" className="h-7" />
        </Link>

        <div className="flex items-center gap-6">
          <MenuProvider menu_id="3">
            <HeaderMenuConsumer />
          </MenuProvider>

<Button className="hidden md:inline-flex hover:-translate-y-0.5" onClick={() => window.open("https://guillermobogao.com/sesion", "_blank")}>
  Reserva sesión gratuita
</Button>
        </div>
      </div>
    </header>;
}